import { render, staticRenderFns } from "./vehicleprofile.vue?vue&type=template&id=15666f62&scoped=true&"
import script from "./vehicleprofile.js?vue&type=script&lang=js&"
export * from "./vehicleprofile.js?vue&type=script&lang=js&"
import style0 from "./vehicleprofile.vue?vue&type=style&index=0&id=15666f62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15666f62",
  null
  
)

export default component.exports